import request from '@/utils/request'

export function getServiceList() {
    return request({
        url: '/hbgwOnstage/homePage/server/info',
        method: 'get'
    })
}